import ViewSettings, { IViewSettings } from "./ViewSettings"

export const SHOW_ONLY_WITH_MACHINES = false

export interface IViewSettingsFairValueEvaluation {
    onlyReferenceNumbersWithMachines?: boolean
}

export default class ViewSettingsFairValueEvaluation extends ViewSettings implements IViewSettings {
    onlyReferenceNumbersWithMachines: boolean = SHOW_ONLY_WITH_MACHINES

    constructor(data: IViewSettingsFairValueEvaluation) {
        super()
        if (typeof data.onlyReferenceNumbersWithMachines !== "undefined") {
            this.onlyReferenceNumbersWithMachines = data.onlyReferenceNumbersWithMachines
        }
    }

    get isDefault() {
        return this.onlyReferenceNumbersWithMachines === SHOW_ONLY_WITH_MACHINES
    }
}
